//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowCardWide",
    props: {
        htmlTag: {
            default: null,
            type: String,
        },
        image: {
            default: () => ({
                height: 1080,
                id: "photo-1601235116901-2dc694b4cb1b",
                ixid: "MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8",
                provider: "unsplash",
                width: 1920,
            }),
            type: Object,
        },
        link: {
            default: null,
            type: String,
        },
        mediaAlign: {
            default: "left",
            type: String,
            validator: (value) => ["left", "right"].includes(value),
        },
        services: {
            default: null,
            type: Object,
        },
        subtitle: {
            default: null,
            type: String,
        },
        pretitle: {
            default: null,
            type: String,
        },
        title: {
            default: null,
            type: String,
        },
    },
    data: () => ({}),
};
